import { Directive } from '@angular/core';
import {
  Validator,
  NG_VALIDATORS,
  ValidatorFn,
  FormControl,
} from '@angular/forms';

@Directive({
  selector: '[passwordValidator]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useClass: PasswordValidatorDirective,
      multi: true,
    },
  ],
})
export class PasswordValidatorDirective implements Validator {
  validator: ValidatorFn;

  constructor() {
    this.validator = this.validatePassword();
  }

  validate(c: FormControl) {
    return this.validator(c);
  }

  validatePassword(): ValidatorFn {
    return (control: FormControl) => {
      if (control.value != null && control.value !== '') {
        const isValid = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,32})/.test(
          control.value
        );
        if (isValid) {
          return null;
        } else {
          return {
            passwordValidator: { valid: false },
          };
        }
      } else {
        return null;
      }
    };
  }
}
